import { localStorageStore } from "ra-core";
import { CRM } from "@/components/atomic-crm/root/CRM";
import {
  authProvider,
  dataProvider,
} from "@/components/atomic-crm/providers/fakerest";
import { DifynWorkbench } from "@/difyn/DifynWorkbench";

const store = localStorageStore(undefined, "DIFYN_CRM");

const App = () => (
  <CRM
    title="Difyn CRM"
    lightModeLogo="./logos/difyn-logo.png"
    darkModeLogo="./logos/difyn-logo.png"
    authProvider={authProvider}
    dataProvider={dataProvider}
    dashboard={DifynWorkbench}
    store={store}
    disableTelemetry
  />
);

export default App;
